export default __webpack_public_path__ + "static/ecvet-horizontal-daf54952592e4ded9f87d3847bd05d56.png";